/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reject_Non_EssentialInputs */

const en_reject_non_essential = /** @type {(inputs: Reject_Non_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential only`)
};

const es_reject_non_essential = /** @type {(inputs: Reject_Non_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo esenciales`)
};

const fr_reject_non_essential = /** @type {(inputs: Reject_Non_EssentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essentiels uniquement`)
};

/**
* | output |
* | --- |
* | "Essential only" |
*
* @param {Reject_Non_EssentialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const reject_non_essential = /** @type {((inputs?: Reject_Non_EssentialInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reject_Non_EssentialInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reject_non_essential(inputs)
	if (locale === "es") return es_reject_non_essential(inputs)
	return fr_reject_non_essential(inputs)
});